// 官网菜单
let websiteMenu = [
  {
    path: "/website/home",
    name: "home",
    component: (resolve) =>
      require(["@/components/website/home/index"], resolve),
    meta: {
      title: "首页",
    },
  },
  {
    path: "/website/business",
    name: "business",
    component: (resolve) => require(["@/components/layout"], resolve),
    meta: {
      title: "主营业务",
    },
    redirect: "/website/business/logistics",
    children: [
      {
        path: "/website/business/logistics",
        name: "logistics",
        component: (resolve) =>
          require(["@/components/website/business/logistics"], resolve),
        meta: {
          title: "物流总包",
        },
      },
      {
        path: "/website/business/number",
        name: "business_number",
        component: (resolve) =>
          require(["@/components/website/business/number"], resolve),
        meta: {
          title: "数智货运",
        },
      },
      {
        path: "/website/business/warning",
        name: "warning",
        component: (resolve) =>
          require(["@/components/website/business/warning"], resolve),
        meta: {
          title: "载途预警",
        },
      },
      {
        path: "/website/business/dataserve",
        name: "dataserve",
        component: (resolve) =>
          require(["@/components/website/business/dataserve"], resolve),
        meta: {
          title: "数据服务",
        },
      },
      {
        path: "/website/business/appreciation",
        name: "appreciation",
        component: (resolve) =>
          require(["@/components/website/business/appreciation"], resolve),
        meta: {
          title: "增值服务",
        },
      },
    ],
  },
  {
    path: "/website/productCenter",
    name: "productCenter",
    component: (resolve) => require(["@/components/layout"], resolve),
    meta: {
      title: "产品中心",
    },
    redirect: "/website/productCenter/owner",
    children: [
      {
        path: "/website/productCenter/owner",
        name: "owner",
        component: (resolve) =>
          require(["@/components/website/productCenter/owner"], resolve),
        meta: {
          title: "世德企业",
        },
      },
      {
        path: "/website/productCenter/driver",
        name: "driver",
        component: (resolve) =>
          require(["@/components/website/productCenter/driver"], resolve),
        meta: {
          title: "世德司机",
        },
      },
      {
        path: "/website/productCenter/tenant",
        name: "tenant",
        component: (resolve) =>
          require(["@/components/website/productCenter/tenant"], resolve),
        meta: {
          title: "世德商户",
        },
      },
      {
        path: "/website/productCenter/operation",
        name: "operation",
        component: (resolve) =>
          require(["@/components/website/productCenter/operation"], resolve),
        meta: {
          title: "世德运营",
        },
      },
      {
        path: "/website/productCenter/eMall",
        name: "shide_e_mall",
        component: (resolve) =>
          require(["@/components/website/productCenter/eMall"], resolve),
        meta: {
          title: "世德e购",
        },
      },
    ],
  },
  {
    path: "/website/solution",
    name: "solution",
    component: (resolve) => require(["@/components/layout"], resolve),
    meta: {
      title: "解决方案",
    },
    redirect: "/website/solution/freight",
    children: [
      {
        path: "/website/solution/freight",
        name: "owner",
        component: (resolve) =>
          require(["@/components/website/solution/freight"], resolve),
        meta: {
          title: "数字货运",
        },
      },
      {
        path: "/website/solution/shop",
        name: "shop",
        component: (resolve) =>
          require(["@/components/website/solution/shop"], resolve),
        meta: {
          title: "数字智购",
        },
      },
      {
        path: "/website/solution/storage",
        name: "tenant",
        component: (resolve) =>
          require(["@/components/website/solution/storage"], resolve),
        meta: {
          title: "数字仓储",
        },
      },
    ],
  },
  {
    path: "/website/enterprise/more",
    name: "more",
    component: (resolve) =>
      require(["@/components/website/enterprise/more"], resolve),
    meta: {
      title: "新闻中心",
      keepAlive: true,
    },
  },
  {
    path: "/website/enterprise/detail/:id",
    name: "enterpriseDetail",
    component: (resolve) =>
      require(["@/components/website/enterprise/detail"], resolve),
    meta: {
      title: "新闻中心详情",
      noMenu: true,
      activePath: "/website/enterprise/more",
    },
  },
  {
    path: "/website/company",
    name: "company",
    component: (resolve) => require(["@/components/layout"], resolve),
    meta: {
      title: "企业介绍",
    },
    redirect: "/website/company/synopses",
    children: [
      {
        path: "/website/company/synopses",
        name: "synopses",
        component: (resolve) =>
          require(["@/components/website/company/synopses"], resolve),
        meta: {
          title: "企业简介",
        },
      },
      {
        path: "/website/company/course",
        name: "course",
        component: (resolve) =>
          require(["@/components/website/company/course"], resolve),
        meta: {
          title: "发展历程",
        },
      },
      {
        path: "/website/company/base",
        name: "baseSet",
        component: (resolve) =>
          require(["@/components/website/company/base"], resolve),
        meta: {
          title: "基础设施",
        },
      },
      {
        path: "/website/company/serve",
        name: "serve",
        component: (resolve) =>
          require(["@/components/website/company/serve"], resolve),
        meta: {
          title: "服务能力",
        },
      },
      {
        path: "/website/company/honor",
        name: "honor",
        component: (resolve) =>
          require(["@/components/website/company/honor"], resolve),
        meta: {
          title: "荣誉资质",
        },
      },
    ],
  },

  {
    path: "/website/partner",
    name: "partner",
    component: (resolve) => require(["@/components/layout"], resolve),
    meta: {
      title: "合作伙伴",
    },
    redirect: "/website/partner/gys",
    children: [
      {
        path: "/website/partner/gys",
        name: "gys",
        component: (resolve) =>
          require(["@/components/website/partner/gys"], resolve),
        meta: {
          title: "煤炭供应商",
        },
      },
      {
        path: "/website/partner/xss",
        name: "xxs",
        component: (resolve) =>
          require(["@/components/website/partner/xss"], resolve),
        meta: {
          title: "煤炭销售商",
        },
      },
    ],
  },

  {
    path: "/website/contact",
    name: "contact",
    component: (resolve) => require(["@/components/layout"], resolve),
    meta: {
      title: "联系我们",
    },
    redirect: "/website/contact/phone",
    children: [
      {
        path: "/website/contact/phone",
        name: "phone",
        component: (resolve) =>
          require(["@/components/website/contact/phone"], resolve),
        meta: {
          title: "联系方式",
        },
      },
      {
        path: "/website/contact/apply",
        name: "apply",
        component: (resolve) =>
          require(["@/components/website/contact/apply"], resolve),
        meta: {
          title: "招贤纳士",
          keepAlive: true,
        },
      },
      {
        path: "/website/contact/applyDetail/:id",
        name: "applyDetail",
        component: (resolve) =>
          require(["@/components/website/contact/applyDetail"], resolve),
        meta: {
          title: "招贤纳士详情",
          noMenu: true,
          activePath: "/website/contact/apply",
        },
      },
    ],
  },
];
export default websiteMenu;



// WEBPACK FOOTER //
// ./src/router/websiteMenu.js